import React, { Component } from 'react';
import { TrashButton, TransparentButton } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import DeleteDialog from '../../portal/dialogs/deleteDialog';
import ActiveIndicator from '../../portal/controls/activeIndicator';
import styles from './style.scss';

export default class SAMLIDPItem extends Component {

    render() {

        const { name, active, deleteSAMLIdpsProgress, 
                    issuer, isManualManagement, translations } = this.props;
        
        const manualAuthorization = isManualManagement ? translations.manualAuthorization : translations.automaticAuthorization;
        
        return(
            <div
                className={styles.samlIdpWrapper}
                data-cy='saml-idp-wrapper'
            >
                <div
                    className={styles.section}
                >
                    <div className='main-details'>
                        <div
                            className={classNames(styles.itemName, 'ellipsis')}
                           title={name}
                           data-cy={'saml-idp-name_' + name}
                        >
                            {name}
                        </div>
                        <div className={styles.samlIdpActive}>
                            <ActiveIndicator
                                active={active}
                                activeText={translations.active}
                                notActiveText={translations.notActive}
                            />
                        </div>
                    </div>
                </div>
                <div
                    className={styles.section}
                >
                    <div className={styles.additionalDetails}>
                        <div>
                            <div>{translations.issuer}:</div>
                            <div>{translations.userAuthorization}:</div>
                        </div>
                        <div
                            className={styles.right}
                        >
                            <div title={issuer}>
                                {issuer}
                            </div>
                            <div title={manualAuthorization}>
                                {manualAuthorization}
                            </div>
                        </div>
                    </div>

                </div>
                <div
                    className={styles.section}
                >
                    <div
                        className={styles.editWrapper}
                    >
                        <TrashButton 
                            onClick={this.props.openDeleteServerDialog}
                            dataCy='btn-delete-server'
                        />
                        <TransparentButton 
                            style={{
                                height: 25,
                                lineHeight: '25px',
                                minWidth: 0
                            }}
                            type='button'
                            onClick={this.props.openEditForm}
                            inProgress={this.props.inProgress}
                            text={ translations.edit}
                            dataCy='btn-edit-server' />
                    </div>
                </div>
            </div>
        );
    }
}